import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { S01ImageSlidesDefault } from "hyam-prismic/components/slices/S01ImageSlidesDefault";
import { S01ImageSlidesDesktopMobileDefault } from "hyam-prismic/components/slices/S01ImageSlidesDesktopMobileDefault";

/**
 * Props for `ImageSlides`.
 */
export type ImageSlidesProps = SliceComponentProps<Content.ImageSlidesSlice>;

/**
 * Component for "ImageSlides" Slices.
 */
const ImageSlides = (props: ImageSlidesProps): JSX.Element => {
  if (props.slice?.variation == "desktopMobile") {
    return <S01ImageSlidesDesktopMobileDefault {...(props as any)} />;
  }
  return <S01ImageSlidesDefault {...(props as any)} />;
};

export default ImageSlides;
